export default __webpack_public_path__ + "static/media/img-step3.54f4c480.png";